/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowFounderContactDtoSchema = z.object({
  name: z.optional(z.string()),
  linkedin: z.optional(z.string()),
});
